<template>
  <v-dialog :value="true" persistent max-width="350">
    <v-card>
      <v-card-title class="headline">Forfeit this offer</v-card-title>
      <v-card-text>
        <v-select
          v-model="selectedProblemType"
          dense
          outlined
          class="mt-6"
          label="What went wrong?"
          item-text="value"
          item-value="type"
          :items="problemTypes"
          :loading="loadingProblemTypes"
          :disabled="submitProblemLoading"
        />
        <v-textarea v-model="problemTypeComments" label="Tell us more" :disabled="submitProblemLoading" />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="darken-1" text :disabled="submitProblemLoading" @click="$emit('offer-unpin-modal-close')">Cancel</v-btn>
        <v-btn color="primary darken-1" text :disabled="reportProblemButtonDisabled" :loading="submitProblemLoading" @click="submitVoucherProblem">
          <v-icon class="mr-1">mdi-delete-outline</v-icon>Forfiet
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'

import { ApiService } from '../services'

export default Vue.extend({
  name: 'OfferUnpin',

  props: {
    voucherId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    problemTypes: [],
    selectedProblemType: null,
    problemTypeComments: '',
    loadingProblemTypes: true,
    submitProblemLoading: false,
  }),

  computed: {
    reportProblemButtonDisabled() {
      return this.loadingProblemTypes || !this.selectedProblemType || (this.selectedProblemType === 'OTHER' && this.problemTypeComments === '')
    },
  },

  mounted: function () {
    ApiService.get('voucherWorkflow/unpinTypes').then((response) => {
      this.loadingProblemTypes = false
      this.problemTypes = response.data
    })
  },

  methods: {
    submitVoucherProblem() {
      this.submitProblemLoading = true

      ApiService.post(`voucherWorkflow/reportProblem/${this.voucherId}`, {
        problemType: this.selectedProblemType,
        comments: this.problemTypeComments,
      }).then(() => {
        this.$store.dispatch('reservations/fetchReservationSummary')

        this.$toast.success("Thanks! We've removed this offer from your claimed offers")

        this.$emit('offer-unpin-modal-unpinned')
      })
    },
  },
})
</script>
